module.exports = __webpack_public_path__ + "jo.f4a6d88a8b724ad6f6c0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/jo.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/jo.svg
// module chunks = styles